import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import { Popover } from "@material-ui/core";
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { getLayers } from '../lib/preferences';

function LayersView(props) {
    const { anchorEl } = props
    const { setSelectedLayer} = props
    const { handleClickAwayFromLayers } = props
    const [layers, setLayersState] = useState(getLayers());

    // refresh from sessionStorage each time the popover opens, in case
    // the available sources changed since it was last read
    useEffect(() => {
      if (anchorEl) {
        setLayersState(getLayers());
      }
    }, [anchorEl]);

    return (
        <Popover open={Boolean(anchorEl)} anchorEl={anchorEl} anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}>
            <Box sx={{ m: 0.5 }} >
              <FormGroup>
                {layers?.map((source) => (
                  <FormControlLabel
                    key={source.id}
                    control={
                      <Checkbox
                        id={source.id}
                        checked={source.selected}
                        onChange={e => {
                          const id = parseInt(e.target.id);
                          const checked = e.target.checked;
                          setSelectedLayer(id, checked);
                          setLayersState(layers.map(l => l.id === id ? { ...l, selected: checked } : l));
                        }}
                      />}
                    label={source.name}
                  />))}
                <Button onClick={() => handleClickAwayFromLayers()}>
                  Close
                </Button>
              </FormGroup>
            </Box>
          </Popover>
    )

}

LayersView.propTypes = {
    setSelectedLayer: PropTypes.func.isRequired,
    anchorEl: PropTypes.bool.isRequired,
    handleClickAwayFromLayers: PropTypes.object.isRequired,
  };
export default LayersView